<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/a2q0J8/tc-custom/9781488076060.jpg?1709100774256" alt="This image is the cover for the book Athens Solution, The Thriller Shorts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Athens Solution, The Thriller Shorts
      </h1>
      <p class="bookDescription body article font2">
        <b>In this action-packed story by a #1 <i>New York Times</i>–bestselling author, a covert agent faces off against a terrorist cell armed with a powerful weapon.</b><br/><br/>A deadly betrayal is at the center of ”The Athens Solution.” When a game-changing weapon falls into the wrong hands, the US Ambassador to Greece must risk everything to recover it, even if it means participating in a ruse that costs his life. With the ambassador dead and the device still at large, covert counterterrorism operative Scot Harvath rushes to eliminate a terror cell about to sell the dangerous technology to Iran. As the sun sets on the Aegean Sea, Harvath must go head-to-head with a traitorous adversary in a confrontation that puts the fate of America and her allies at risk . . . <br/><br/>Originally published in the short story anthology, <i>Thriller</i>, ”The Athens Solution” has been revised and includes a brand new, bonus afterword. This riveting addition to the Scot Harvath thrillers delivers all the pulse-pounding action and high stakes fans have come to know and love from Brad Thor. Without a doubt, ”The Athens Solution” will leave fans hungry for more!<br/><br/><b>Praise for “The Athens Solution”</b><br/><br/>“Nobody can pack as much action into fifty pages as Brad Thor . . . Undoubtedly the best short story I’ve ever read.” —The Real Book Spy
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brad Thor, James Patterson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e9039b1a